import React from 'react';
import { ErrorNotificationCtx } from '../@types/seen-apps';

const ErrorNotificationContext = React.createContext<ErrorNotificationCtx>({
  error:{
  },
  setError:() => {},
});

export default ErrorNotificationContext;